"use strict";
/**
 * @description: device sign工具模块
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceSignUtil = exports.deviceSign2DeviceId = void 0;
var md5 = require("md5");
var sdk_1 = require("@xbase/sdk");
var domain_1 = require("@xunlei/xluser-base/dist/common/domain");
var websdk2_cookie_util_1 = require("../common/websdk2-cookie-util");
// 历史原因，存储在本地的key为deviceid，但是value存的是deviceSign
var DeviceSignStorageName = 'deviceid';
var DeviceSignExpireIn = 7 * 24 * 3600 * 1000;
var domain = domain_1.getMainDomain();
/**
 * deviceSign转diviceId。
 *
 * @param {string | undefined} deviceSign
 * @return {string | undefined}
 */
function deviceSign2DeviceId(deviceSign) {
    var deviceId = undefined;
    if (typeof deviceSign === 'string') {
        var pos = deviceSign.indexOf('.');
        if (pos > -1) {
            deviceId = deviceSign.substr(pos + 1, 32);
        }
        if (typeof deviceId !== 'string' || deviceId.length != 32) {
            deviceId = undefined;
        }
    }
    return deviceId;
}
exports.deviceSign2DeviceId = deviceSign2DeviceId;
/**
 * deviceSign前端的处理逻辑跟websdk2.0的处理逻辑保持一致，保存在localStroage和cookie的字段为deviceId。
 */
var DeviceSignUtil = /** @class */ (function () {
    /**
     *
     */
    function DeviceSignUtil() {
        this._cookieUtil = new websdk2_cookie_util_1.WebSDK2CookieUtil();
    }
    /**
     * 初始化。
     * 需要跟客户端同步，则需要传入nativeApi。
     *
     * @param {string} apiOrigin
     * @param {NativeApi} nativeApi
     * @param {boolean} enableLocalDeviceSignInWeb 在Web环境中使用本地的deviceSign数据，无法通过服务端校验，仅限于海外项目未部署deviceSign服务时使用。
     */
    DeviceSignUtil.prototype.init = function (apiOrigin, nativeApi, enableLocalDeviceSignInWeb) {
        return __awaiter(this, void 0, void 0, function () {
            var currentTime, deviceSign, fpRaw, fp, error_1, uuid, appInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._nativeApi = nativeApi;
                        currentTime = new Date().getTime();
                        if (!!this._nativeApi) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.trySynchronizeWebDeviceSign(currentTime)];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        deviceSign = undefined;
                        if (!!this._nativeApi) return [3 /*break*/, 7];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        fpRaw = this._uuidv4();
                        fp = md5(fpRaw);
                        return [4 /*yield*/, this._requestDeviceSign(apiOrigin, currentTime, fpRaw, fp)];
                    case 4:
                        deviceSign = _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        if (enableLocalDeviceSignInWeb) {
                            uuid = this._uuidv4();
                            deviceSign = "wdi10." + uuid + "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx";
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this._nativeApi.getAppInfo()];
                    case 8:
                        appInfo = _a.sent();
                        deviceSign = appInfo.deviceSign;
                        _a.label = 9;
                    case 9:
                        // 设置deviceSign数据。
                        this._setNewDeviceSign(currentTime, deviceSign || '');
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 尝试同步纯web本地数据。
     *
     * @param {number} currentTime
     * @return {boolean} 成功同步了有效的deviceSign则返回true。
     */
    DeviceSignUtil.prototype.trySynchronizeWebDeviceSign = function (currentTime) {
        // 如果是纯网页，需要先同步cookie和storage的deviceSign数据
        // 上报指纹条件: 1.不存在deviceSign 2.deviceSign有效时间到达，需要再次校验
        var storageDeviceSign = this._getLocalStorageDeviceSign();
        var storageDeviceSignCreateTime = parseInt(window.localStorage.getItem('xl_fp_rt') || '');
        var isStorageDeviceSignValid = !!storageDeviceSign &&
            storageDeviceSign.length > 20 &&
            currentTime - storageDeviceSignCreateTime < DeviceSignExpireIn;
        var cookieDeviceSign = this._cookieUtil.getCookie(DeviceSignStorageName);
        cookieDeviceSign =
            typeof cookieDeviceSign === 'string' ? cookieDeviceSign : '';
        var cookieDeviceSignCreateTime = this._to_time_number(this._cookieUtil.getCookie('xl_fp_rt'));
        var isCookieDeviceSignValid = cookieDeviceSign.length > 20 &&
            currentTime - cookieDeviceSignCreateTime < DeviceSignExpireIn;
        // 根据校验情况重新存储deviceSign
        if (isStorageDeviceSignValid && !isCookieDeviceSignValid) {
            this._cookieUtil.setCookie(DeviceSignStorageName, storageDeviceSign || '', domain, currentTime - storageDeviceSignCreateTime);
            this._cookieUtil.setCookie('xl_fp_rt', "" + storageDeviceSignCreateTime, domain, currentTime - storageDeviceSignCreateTime);
        }
        else if (!isStorageDeviceSignValid && isCookieDeviceSignValid) {
            window.localStorage.setItem(DeviceSignStorageName, cookieDeviceSign);
            window.localStorage.setItem('xl_fp_rt', "" + cookieDeviceSignCreateTime);
        }
        else if (isStorageDeviceSignValid && isCookieDeviceSignValid) {
            // deviceSign都有效且数据不一致时，以cookie为主
            if (storageDeviceSign !== cookieDeviceSign ||
                storageDeviceSignCreateTime !== cookieDeviceSignCreateTime) {
                window.localStorage.setItem(DeviceSignStorageName, cookieDeviceSign);
                window.localStorage.setItem('xl_fp_rt', "" + cookieDeviceSignCreateTime);
            }
        }
        // 只要有一个有效的，就完成了重新存储数据，无需服务器校验
        return isStorageDeviceSignValid || isCookieDeviceSignValid;
    };
    /**
     * 获取device sign。
     *
     * @return {string}
     */
    DeviceSignUtil.prototype.getDeviceSign = function () {
        return this._getLocalStorageDeviceSign();
    };
    /**
     * 设置新device sign。
     *
     * @param {number} time
     * @param {string} deviceSign
     */
    DeviceSignUtil.prototype._setNewDeviceSign = function (time, deviceSign) {
        window.localStorage.setItem(DeviceSignStorageName, deviceSign);
        window.localStorage.setItem('xl_fp_rt', "" + time);
        this._cookieUtil.setCookie(DeviceSignStorageName, deviceSign, domain, DeviceSignExpireIn);
        this._cookieUtil.setCookie('xl_fp_rt', "" + time, domain, DeviceSignExpireIn);
    };
    /**
     * 请求生成device sign。
     *
     * @param {string} apiOrigin
     * @param {number} time
     * @param {string} fpRaw
     * @param {string} fp
     */
    DeviceSignUtil.prototype._requestDeviceSign = function (apiOrigin, time, fpRaw, fp) {
        return __awaiter(this, void 0, void 0, function () {
            var fpSign;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._cookieUtil.loadScript(apiOrigin + "/risk?cmd=algorithm&t=" + time)];
                    case 1:
                        _a.sent();
                        fpSign = xl_al(fpRaw);
                        return [4 /*yield*/, sdk_1.defaultRequest(apiOrigin + "/risk?cmd=report", {
                                method: 'POST',
                                body: {
                                    xl_fp_raw: fpRaw,
                                    xl_fp: fp,
                                    version: 2,
                                    xl_fp_sign: fpSign,
                                },
                            })];
                    case 2: 
                    // 接口返回的deviceId对应的是deviceSign。
                    return [2 /*return*/, (_a.sent()).deviceid];
                }
            });
        });
    };
    /**
     * 将时间戳字符串转为时间戳数值，不合法则转为0。
     *
     * @param {string | null | undefined} timeString
     * @return {number}
     */
    DeviceSignUtil.prototype._to_time_number = function (timeString) {
        if (typeof timeString === 'string') {
            var num = Number(timeString);
            if (!isNaN(num)) {
                return parseInt(timeString);
            }
        }
        return 0;
    };
    /**
     * 获取本地device sign。
     *
     * @return {string}
     */
    DeviceSignUtil.prototype._getLocalStorageDeviceSign = function () {
        // websdk生成的storage的数据会带上多余的单引号
        var deviceSign = window.localStorage.getItem(DeviceSignStorageName);
        if (typeof deviceSign === 'string') {
            deviceSign = deviceSign.replace(/'/g, '').replace(/"/g, '');
        }
        else {
            deviceSign = undefined;
        }
        return deviceSign;
    };
    /**
     * 生成随机uuid字符串。
     *
     * @return {string}
     */
    DeviceSignUtil.prototype._uuidv4 = function () {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0;
            var v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };
    return DeviceSignUtil;
}());
exports.DeviceSignUtil = DeviceSignUtil;
//# sourceMappingURL=index.js.map